import Radio from "../Radio";
import { TRadioGroupProps, TRadioOption } from "../types";

const getKey = (name: string, value: string | number, i: number): string => `${name}-${value}-${i}`;

function mapRadioList(
  options: TRadioOption[],
  commonProps: Omit<TRadioGroupProps, "value" | "label" | "options" | "onChange">
): JSX.Element[] {
  return options.map(({ value, label, ...rest }: TRadioOption, index: number) => (
    <Radio value={value} key={getKey(commonProps.name || "field", value, index)} isInGroup {...commonProps} {...rest}>
      {label}
    </Radio>
  ));
}
export default mapRadioList;
